import PeiixLogoB from '../img/Peiix_logotipo_color.png';
import { Container } from "react-bootstrap";
import { Col, Row } from "antd";
import '../Styles/Navbar.css';
import { useEffect, useState } from 'react';
import isotipo from '../img/isotipo.png';

const NavBarPeiix = () => {

    const [nombreComercial, setNombreComercial] = useState(''); // Estado para el nombre comercial

    useEffect(() => {
        const nombre = localStorage.getItem('nombre_comercial');
        if (nombre) {
            setNombreComercial(nombre); // Establecer el nombre comercial si existe
        }
    }, []);


    return (
        <>
            <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className='navbar-imgl' style={{ flex: '0 0 auto' }}>
                    <img
                        src={PeiixLogoB}
                        alt="Peiix LogoB"
                        style={{ height: '30px', maxWidth: '150px' }} // Estilo directo o en CSS
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
                    <img
                        src={isotipo}
                        alt="Commercial Logo"
                        style={{ width: '60px', height: '60px', borderRadius: '100%', border: '3px solid #8EC100' }}
                    />
                    <span className='h5' style={{ marginLeft: '10px', fontWeight: 'bold', color: '#3e3e3e', fontFamily: 'Montserrat, sans-serif' }}>
                        {nombreComercial || 'Usuario'}
                    </span>
                </div>
            </div>
            <div style={{ height: '1px', backgroundColor: '#ccc' }} />
        </>
    );
}

export default NavBarPeiix;